import React from 'react';

export interface UbicacionIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const UbicacionIcon: React.FC<UbicacionIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M22.339 10.417c0 7.292-9.375 13.542-9.375 13.542s-9.375-6.25-9.375-13.542a9.375 9.375 0 1 1 18.75 0"/><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12.964 13.542a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25"/>
    </svg>
  );
};

export default UbicacionIcon;
